
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  locale: 'en-US',
  timeZone: 'UTC',
  dateFormat: 'yyyy-MM-dd HH:mm:ss',
  currencyFormat: {
    style: 'currency',
    currency: 'USD',
  },
};

const globalizationSlice = createSlice({
  name: 'globalization',
  initialState,
  reducers: {
    setLocale: (state, action) => {
      state.locale = action.payload;
    },
    setTimeZone: (state, action) => {
      state.timeZone = action.payload;
    },
    setDateFormat: (state, action) => {
      state.dateFormat = action.payload;
    },
    setCurrencyFormat: (state, action) => {
      state.currencyFormat = action.payload;
    },
  },
});

export const { setLocale, setTimeZone, setDateFormat, setCurrencyFormat } = globalizationSlice.actions;
export default globalizationSlice.reducer;
